import { render } from "./VideoPlayerControlsSettings.vue?vue&type=template&id=95c6e960&scoped=true"
import script from "./VideoPlayerControlsSettings.vue?vue&type=script&lang=js"
export * from "./VideoPlayerControlsSettings.vue?vue&type=script&lang=js"

import "./VideoPlayerControlsSettings.vue?vue&type=style&index=0&id=95c6e960&lang=scss&scoped=true"

import exportComponent from "/Users/sxdube/Documents/code/vue-viewer-plugin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95c6e960"]])

export default __exports__